import React from 'react'
import InvertColorsIcon from '@material-ui/icons/InvertColors'
import {IconButton, Tooltip} from '@material-ui/core';
import InvertColorsOffIcon from '@material-ui/icons/InvertColorsOff'
import {connect} from 'react-redux'
import {setContrastColors} from 'redux/actions'
import Tr from 'translations/Translations';

function InvertColorsButton(
	{
		contrast,
		setContrastColors
	}) {
	const Icon = contrast ? InvertColorsOffIcon : InvertColorsIcon;

	const handleClick = () => {
		setContrastColors(!contrast);
	}

	return (
		<Tooltip title={Tr('contrast_colors')}>
			<IconButton onClick={handleClick}>
				<Icon/>
			</IconButton>
		</ Tooltip>
	)
}

export default connect((state) => ({
	contrast: state.store.contrast
}), {
	setContrastColors
})(InvertColorsButton);
